/*
  ============================================================
  carrinho.js — Helper de carrinho (add-to-cart via AJAX)
  ============================================================

  O QUE FAZ:
  Melhoria progressiva para adicionar produtos ao carrinho sem
  recarregar a pagina. Intercepta o envio de qualquer formulario
  de add-to-cart, envia para a Cart AJAX API do Shopify
  (/cart/add.js), atualiza o contador do carrinho no header
  (buscando /cart.js) e mostra uma confirmacao leve via
  window.mostrarAlerta (definido em snippets/alerta.liquid).

  OBSERVACOES:
  Funciona sem JS: o formulario de produto ja envia nativamente
  para /cart/add. Se a requisicao AJAX falhar, o script faz
  fallback e submete o formulario do jeito tradicional.
  O contador usa elementos com [data-cart-count]. O texto do
  alerta vem de window.themeStrings.addedToCart quando disponivel.
*/
(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (added) {
        // /cart/add.js devolve a linha unica, ou { items: [...] } em bundles.
        var item = added && added.items ? added.items[0] : added;
        // Busca o carrinho completo (total/contador) para alimentar o popup.
        var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            // Popup rico "Adicionado a sacola"; cai para o toast se indisponivel.
            if (typeof window.mostrarSacolaPopup === 'function') {
              window.mostrarSacolaPopup(item, cart);
            } else if (typeof window.mostrarAlerta === 'function') {
              window.mostrarAlerta(
                (window.themeStrings && window.themeStrings.addedToCart) || 'Adicionado à sacola',
                'positivo'
              );
            }
          });
      })
      .catch(function () {
        // Fallback: submit the form the normal way.
        form.submit();
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();

/*
  Favoritos (coração dos cards) — visual, persistido em localStorage.
  Alterna aria-pressed no botão [data-wishlist]; nao cria pedido/lista no servidor.
*/
(function () {
  'use strict';
  var KEY = 'madame:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(ids) {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function mark() {
    var ids = read();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', ids.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist]') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var ids = read();
    var i = ids.indexOf(id);
    if (i === -1) { ids.push(id); btn.setAttribute('aria-pressed', 'true'); }
    else { ids.splice(i, 1); btn.setAttribute('aria-pressed', 'false'); }
    write(ids);
  });

  document.addEventListener('DOMContentLoaded', mark);
})();

/*
  Animações estilo Vivara:
  - Reveal ao rolar: adiciona .is-inview aos [data-reveal] quando entram na tela.
  (O comportamento de compactar o cabeçalho ao rolar é tratado no próprio
   sections/nav.liquid, com transição suave via FLIP.)
*/
(function () {
  'use strict';

  function run() {
    var reveals = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-inview'); });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
})();
